import React, { useEffect, useState } from "react";
import { getKeyboardStatus, getTooltipStatus } from "../../src/store/user";
import { useSelector, useDispatch } from "react-redux";
import { setKeyboardStatusRedux } from "../reduxSlices/keyboardSlices";
import { useTranslation } from "react-i18next";
import { getWidgetSettings } from "../serivces/widgetService";

function DisplayCard({ items, selectedData, color, isHighlighted }) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [subtitleVisible, setSubtitleVisible] = useState(false);
  const [widgetSettings, setWidgetSettings] = useState(null);
  const [dynamicColor, setDynamicColor] = useState(null);
  const keyboardStatus = useSelector((state) => state.keyboard.keyboardStatus);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const gradientColor = dynamicColor || color;

  const extractColors = (gradient) => {
    const matches = gradient.match(/#(?:[0-9a-fA-F]{3}){1,2}/g);
    const [firstColor, secondColor] = matches || ["#000000", "#000000"];
    return { firstColor, secondColor };
  };

  const { firstColor, secondColor } = extractColors(gradientColor);

  useEffect(() => {
    getWidgetData();
    let status = getKeyboardStatus();
    if (status) {
      dispatch(setKeyboardStatusRedux(status));
    }
  }, []);

  useEffect(() => {
    if (
      getTooltipStatus() != null &&
      getTooltipStatus() !== undefined &&
      getTooltipStatus() === true
    ) {
      setSubtitleVisible(true);
    } else {
      setSubtitleVisible(false);
    }
  }, [isHovering, items.isSelected]);

  useEffect(() => {
    if (keyboardStatus === false) {
      setIsTooltipOpen(false);
    }
  }, [keyboardStatus]);

  const getWidgetData = async () => {
    const resp = await getWidgetSettings();
    const settings = resp;
    setWidgetSettings(settings);
    const buttonColors = settings?.appearance?.colors?.button;
    const isGradientEnabled = buttonColors?.gradientEnabled;
    if (
      isGradientEnabled &&
      buttonColors?.color &&
      buttonColors?.colorGradientEnd
    ) {
      setDynamicColor(
        `linear-gradient(227deg, ${buttonColors.color} -19.89%, ${buttonColors.colorGradientEnd} 98.7%)`,
      );
    } else {
      setDynamicColor(buttonColors.color || null);
    }
  };

  return (
    <div className="relative flex items-center justify-center w-full h-full">
      <button
        disabled={items.commingSoon === true}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        className={`relative focus:outline-none focus:ring-1 focus:ring-[#3B4395] rounded ${
          items.commingSoon === true
            ? "disableSelection displayCardUnSelected"
            : items.isSelected
              ? "displayCardSelected"
              : items.isMobileActive
                ? "displayCardUnSelected"
                : "disableSelectionMobile displayCardUnSelected"
        } ${isHighlighted ? "highlighted-card" : ""}`}
        style={
          items.isSelected
            ? gradientColor?.includes("linear-gradient")
              ? {
                  background: `linear-gradient(227deg, ${firstColor} -19.89%, ${secondColor} 98.7%)`,
                }
              : {
                  backgroundColor: gradientColor,
                }
            : undefined
        }
      >
        {items.totalTapCount > 0 ? (
          <div className="w-[1.74rem] h-[1.8125rem] shrink-0 aspect-square">
            <div
              style={{
                backgroundImage: `url(${
                  items.isSelected
                    ? items.items[items.currentCount - 1].icon
                    : items.iconUnselected
                })`,
              }}
              className="w-[1.75rem] h-[1.75rem] bg-no-repeat bg-center bg-contain"
            />
          </div>
        ) : (
          <div className="w-[1.74rem] h-[1.8125rem] shrink-0 aspect-square">
            <div
              style={{
                backgroundImage: `url(${
                  items.isSelected ? items.iconSelected : items.iconUnselected
                })`,
              }}
              className="w-[1.75rem] h-[1.75rem] bg-no-repeat bg-center bg-contain"
            />
          </div>
        )}

        {items.tooltip && keyboardStatus && (
          <button
            style={{
              backgroundImage: `url(${
                items.isSelected
                  ? "/tooltip/infoIconselected.svg"
                  : "/tooltip/infoIcon.svg"
              })`,
            }}
            className="w-[1.25rem] h-[1.25rem] bg-no-repeat bg-center bg-contain absolute top-3 right-3 rounded-[100%]"
            onClick={(e) => {
              e.stopPropagation();
              setIsTooltipOpen(!isTooltipOpen);
            }}
          />
        )}

        {items.totalTapCount > 0 ? (
          <div
            className={`${
              items.isSelected
                ? "displayCardSelectedTitle"
                : "displayCardUnselectedTitle"
            }`}
          >
            {items.currentCount - 1 === -1
              ? t(items.title)
              : t(items.items?.[items.currentCount - 1]?.subItemTitle)}
          </div>
        ) : (
          <div
            className={`${
              items.isSelected
                ? "displayCardSelectedTitle"
                : "displayCardUnselectedTitle"
            }`}
          >
            {t(items.title)}
          </div>
        )}

        {items.totalTapCount > 0 && (
          <div className="absolute bottom-[0.813rem] flex items-center justify-center gap-[0.35rem]">
            {[...Array(items.totalTapCount + 1)].map((_, index) => (
              <div
                key={index}
                style={{ width: `${5.625 / (items.totalTapCount + 1)}rem` }}
                className={`h-[0.125rem] rounded-[1rem] ${
                  index < items.currentCount && items.isSelected
                    ? "bg-primary-background"
                    : items.isSelected
                      ? "bg-[#9E9E9E]"
                      : "bg-secondary-background"
                }`}
              />
            ))}
          </div>
        )}

        {isTooltipOpen && keyboardStatus && (
          <div className="absolute flex items-center justify-center pointer-events-none top-0 right-0 left-0 bottom-0">
            <div className="bg-black rounded-md p-[1rem] drop-shadow-tooltip-shadow toolTipDisplayCard w-[100%]">
              <div className="text-white font-bold text-primary text-center">
                {t(items.tooltip)}
              </div>
            </div>
          </div>
        )}

        {isHovering && items.subtitle && subtitleVisible && (
          <div className="absolute bottom-full mb-3 left-1/2 transform -translate-x-1/2 z-[9999] flex flex-col items-center">
            <div className="w-max max-w-[10vw] p-[0.75rem] bg-black text-white text-xs rounded-lg shadow-lg text-center text-wrap leading-0 font-[500]">
              {t(items.subtitle)}
            </div>
            <div className="w-3 h-3 bg-black rotate-45 -mt-2"></div>
          </div>
        )}
      </button>

      {items.commingSoon && (
        <img
          src="/accessbilityProfile/profileInner/selected/ribbon.svg"
          alt="commingsoonribbon"
          className="absolute top-0 right-0 rounded-[0.5rem]"
        />
      )}
    </div>
  );
}

export default DisplayCard;
